module.exports = __webpack_public_path__ + "static/media/CT_2019_30443A.82fe9511.png";